<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.90567 2H3.52373C2.68327 2 1.99951 2.68376 1.99951 3.52421V8.90636C1.99951 9.74681 2.68327 10.4306 3.52373 10.4306H8.90572C9.74617 10.4306 10.4299 9.74681 10.4299 8.90636V3.52421C10.4299 2.68376 9.74612 2 8.90567 2ZM3.52373 8.90631V3.52421H8.90572L8.90588 8.90636L3.52373 8.90631Z"
      fill="white"
    />
    <path
      d="M14.9778 10.4305H20.3598C21.2003 10.4305 21.884 9.74676 21.884 8.90631V3.52421C21.884 2.68376 21.2003 2 20.3598 2H14.9778C14.1374 2 13.4536 2.68376 13.4536 3.52421V8.90636C13.4536 9.74676 14.1374 10.4305 14.9778 10.4305ZM14.9778 3.52421H20.3598L20.36 8.90636H14.9778V3.52421Z"
      fill="white"
    />
    <path
      d="M8.90567 13.454H3.52373C2.68327 13.454 1.99951 14.1377 1.99951 14.9782V20.3604C1.99951 21.2008 2.68327 21.8846 3.52373 21.8846H8.90572C9.74617 21.8846 10.4299 21.2008 10.4299 20.3604V14.9782C10.4299 14.1377 9.74612 13.454 8.90567 13.454ZM3.52373 20.3603V14.9782H8.90572L8.90588 20.3604L3.52373 20.3603Z"
      fill="white"
    />
    <path
      d="M21.7796 20.7023L20.7213 19.6441C21.1491 19.0103 21.3992 18.2472 21.3992 17.4266C21.3992 15.2361 19.617 13.454 17.4264 13.454C15.2358 13.454 13.4536 15.2361 13.4536 17.4266C13.4536 19.6175 15.2358 21.3998 17.4264 21.3998C18.2468 21.3998 19.0099 21.1497 19.6436 20.7218L20.7019 21.7801C21.016 22.0943 21.5473 22.0678 21.8296 21.7251C22.0757 21.4262 22.0532 20.9759 21.7796 20.7023ZM19.8746 17.4264C19.8746 18.7786 18.7785 19.8747 17.4263 19.8747C16.0741 19.8747 14.978 18.7786 14.978 17.4264C14.978 16.0743 16.0742 14.9781 17.4263 14.9781C18.7785 14.9781 19.8746 16.0743 19.8746 17.4264Z"
      fill="white"
    />
  </svg>
</template>
